import { Component } from '@angular/core';
import {environment} from '../../../../../environments/environment';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [
        MatToolbarModule,
        MatTooltipModule,
        FlexLayoutModule,
        NgOptimizedImage,
        TranslateModule,
        RouterModule
    ]
})
export class FooterComponent {
  getVersion(): any {
    return environment.appVersion;
  }
}
